module.exports = __webpack_public_path__ + "img/SES_38069440.c617dac2.jpg";